// Derived per-day indexes over the game state (perf). Nothing here is stored in the state (saves and state hashes
// are unaffected): caches live in WeakMaps keyed by the state's own collections, so a loaded save, a Quick Start
// (which replaces state.wells) or a test that swaps collections rebuilds them. No imports: safe from any module.
//
// Validity: an index is rebuilt when the collection object changes, the day changes, or its key count changes
// (wells are only ever added by drilling.createWell; tests add/delete wells by hand — the count check catches that
// outside a tick).
// Callers read live objects through the index; only membership is cached, so values never go stale.

const countKeys = (o) => { let n = 0; for (const _ in o) n++; return n; };

// Inside tick() the sim only adds wells through drilling.createWell, which calls wellAdded(): the key count check
// (O(wells) per lookup) is skipped there. Outside a tick (UI, actions, tests poking state.wells) it always runs.
let IN_TICK = false;
export function setInTick(on) { IN_TICK = on; }
export function wellAdded(state) { if (state.wells) WELLS.delete(state.wells); }

const WELLS = new WeakMap(); // state.wells -> { day, n, list, byField }
function wellIdx(state) {
  const wells = state.wells ?? {};
  let e = WELLS.get(wells);
  if (IN_TICK && e && e.day === state.day) return e;
  const n = countKeys(wells);
  if (e && e.day === state.day && e.n === n) return e;
  const list = Object.values(wells);
  const byField = new Map();
  for (const w of list) { let a = byField.get(w.fieldId); if (!a) byField.set(w.fieldId, (a = [])); a.push(w); }
  e = { day: state.day, n, list, byField };
  WELLS.set(wells, e);
  return e;
}

const NONE = Object.freeze([]);
// Wells on a field, in state.wells insertion order (the order Object.values gives: sums stay bit-identical).
export function wellsOnField(state, fieldId) { return wellIdx(state).byField.get(fieldId) ?? NONE; }
// All wells (shared array — do not mutate).
export function allWells(state) { return wellIdx(state).list; }
